<template>
  <div class="pagination-container">
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="currentPage"
      :page-sizes="[10, 15, 20, 25]"
      :page-size.sync="pageSize"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: ["total", "page", "rows"],
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.rows;
      },
      set(val) {
        this.$emit("update:rows", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.currentPage, rows: val });
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, rows: this.pageSize });
    },
  },
};
</script>

<style lang="less" scoped>
.pagination-container {
  padding: 32px 16px;
  margin-top: 30px;
}
</style>
